import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import WarningBox from '../WarningBox/WarningBox';

const WithdrawalMethodWarningBox = () => {
  const { t } = useTranslation();
  const history = useHistory();
  

  const user = useSelector((state) => state.associates.user);
  const userEmail = user?.email;
  const advantageNetworkStatus = useSelector(
    (state) => state.associates.user.advantageNetworkStatus,
  );
  const userWithdrawalMethod = user?.userWithdrawalMethod;

  const wireMethod =
    user.withdrawalMethod === 'WIRE_INTERNATIONAL' || user.withdrawalMethod === 'WIRE_MEXICO';
  const cashOrCertificate =
    user.withdrawalMethod === 'CASH' || user.withdrawalMethod === 'CERTIFICATE';

  if (advantageNetworkStatus !== 'APPROVED' && !userWithdrawalMethod) {
    return null;
  }

  if (userWithdrawalMethod && userWithdrawalMethod.isActive) {
    return null;
  }

  if (cashOrCertificate) {
    return null;
  }

  let title = '';
  let subtitle = '';
  let nextUrl = '';

  if (user.withdrawalMethod === 'STRIPE') {
    if (userWithdrawalMethod?.status === 'WAITING_FIRST_PAYMENT') {
      return null;
    } else if (
      userWithdrawalMethod == null ||
      userWithdrawalMethod.status === 'WAITING_USER_CREATION'
    ) {
      // user needs to create its connected account
      title = t('noAccountAssociated.STRIPE.title');
     subtitle = t('noAccountAssociated.STRIPE.subtitle', {email: userEmail});
      nextUrl = null;
    } else if (userWithdrawalMethod?.status === 'PENDING_TOS_ACCEPTANCE') {
      // user needs to provide additional info for its connected account
      title = t('reviewConnectedAccountRequired.title');
      subtitle = t('reviewConnectedAccountRequired.subtitle');
      nextUrl = `/confirm-add-account/?id=${userWithdrawalMethod.userWithdrawalMethodId}`;
    } else if (userWithdrawalMethod?.status === 'PENDING_REVIEW') {
      title = t('accountBeingReviewed.title');
      subtitle = '';
      nextUrl = null;
    }
  } else if (user.withdrawalMethod === 'MERCADOPAGO') {
    title = t('noAccountAssociated.mercadoPago.title');
    subtitle = t('noAccountAssociated.mercadoPago.subtitle');
    nextUrl = '/mercadopagoaccount';
  } else if (wireMethod) {
    title = t('noAccountAssociated.WIRE.title');
    subtitle = t('noAccountAssociated.WIRE.subtitle');
    if (user.withdrawalMethod === 'WIRE_INTERNATIONAL') {
      nextUrl = '/international-bank';
    } else if (user.withdrawalMethod === 'WIRE_MEXICO') {
      nextUrl = '/national-bank';
    }
  }

  return (
    <WarningBox
      title={title}
      subtitle={<div>{subtitle}.</div>}
      onClick={() => history.push(nextUrl)}
    />
  );
};

export default WithdrawalMethodWarningBox;
